module.exports = __webpack_public_path__ + "media/src/images/icons/FN_logomark_white-dda976b5bc3e8bb1a88d714e519dbea0.svg";